import { render } from "./Config.vue?vue&type=template&id=7ef1f048&scoped=true&ts=true"
import script from "./Config.vue?vue&type=script&lang=ts"
export * from "./Config.vue?vue&type=script&lang=ts"

import "./Config.vue?vue&type=style&index=0&id=7ef1f048&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef1f048"]])

export default __exports__